var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgH2 = function SvgH2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A89A6",
    strokeWidth: 0.094,
    d: "M22.088 16.033a.96.96 0 0 0-.142.264.89.89 0 1 1-1.68-.594 2.766 2.766 0 1 1 4.817 2.587l-2.245 2.994-.057.075h1.969a.89.89 0 0 1 0 1.782H21a.89.89 0 0 1-.712-1.425l-.038-.029.038.029 3.37-4.497h.001a.984.984 0 1 0-1.57-1.186Zm0 0 .038.028-.038-.028ZM16.36 16v-.047h-6.343v3.797a.89.89 0 0 1-1.782 0v-9.375a.89.89 0 0 1 1.782 0v3.797h6.343v-3.797a.89.89 0 1 1 1.782 0v9.375a.89.89 0 0 1-1.782 0V16Z"
  })));
};
export default SvgH2;